class StoreUser {
  constructor (
    id = undefined,
    email,
    password,
    roleId,
    createdAt
  ) {
    this.id = id
    this.email = email
    this.password = password
    this.roleId = roleId
    this.role = null
    this.createdAt = createdAt
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      email: this.email,
      password: this.password,
      role: this.roleId
      // createdAt is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    email,
    roleId,
    createdAt
  }) {
    return new StoreUser(
      id,
      email,
      undefined,
      roleId,
      createdAt
    )
  }

  toJSON () {
    return {
      id: this.id,
      email: this.email,
      password: this.password,
      roleId: this.roleId,
      createdAt: this.createdAt
    }
  }

  static FromJSON ({
    id,
    email,
    password,
    roleId,
    createdAt
  }) {
    return new StoreUser(
      id,
      email,
      password,
      roleId,
      createdAt
    )
  }
}

export default StoreUser
